import { Context } from 'effect';
import type { Effect, Stream } from 'effect';

import { ContextTag } from '../context';

/** Browser broadcast-channel port; the shell owns its Live implementation. */
export type SyncMessage = 'tokens-updated' | 'tokens-cleared';

export type StorageSyncService = {
  readonly broadcastTokensUpdated: Effect.Effect<void>;
  readonly broadcastTokensCleared: Effect.Effect<void>;
  readonly changes: Stream.Stream<SyncMessage>;
};

export class StorageSync extends Context.Service<StorageSync, StorageSyncService>()(
  ContextTag.StorageSync
) {}
